import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  getCourseById,
  getRelatedCourses,
} from "../../components/cephas-kids/CourseData";
import Nav from "../../components/nav/nav.component";
import RelatedCourses from "../../components/cephas-kids/RelatedCourses";
import WhatWeOffer from "../../components/cephas-kids/what-we-offer";
import WhatSetsUsApart from "../../components/cephas-kids/WhatSetsUsApart";
import Testimonials from "../../components/cephas-kids/Testimonials";
import FAQ from "../../components/cephas-kids/Faq";
import NewsletterSubscription from "../../components/cephas-kids/NewsletterSubscription";
import Footer from "../../components/footer/footer.component";
import CurriculumModal from "../../components/cephas-kids/CurriculumModal";
// import CurriculumModal from "../../components/modals/CurriculumModal";

const CourseDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const course = getCourseById(id);
  const relatedCourses = getRelatedCourses(id, 2);
  const [showCurriculumModal, setShowCurriculumModal] = useState(false);

  return (
    <div className="min-h-screen">
      {/* Navbar is always rendered with light variant */}
      <Nav variant="dark" />
      {course ? (
        <>
          {/* Course Detail Section */}
          <div className="pt-24 pb-16 px-4 md:px-6 lg:px-16 bg-gradient-to-r from-[#FF4B01]/5 to-[#113296]/10">
            <div className=" mx-auto">
              <div className="grid grid-cols-1 lg:flex items-center gap-12">
                {/* Course Content - Left Column */}
                <div className=" lg:w-[47%] md:w-full w-full">
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-DM_SANS font-bold text-[#113296] mb-6">
                    {course.title}
                  </h1>
                  <div className="prose prose-lg max-w-none mb-8">
                    <p className="text-[#1B1B1B] font-DM_SANS font-normal text-lg leading-relaxed text-justify">
                      {course.description}
                    </p>
                  </div>
                  <a
                    href="http://tinyurl.com/cephaskids"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="bg-[#FF4B01] font-Outfit font-medium text-xl hover:bg-orange-600 text-white px-8 py-3 rounded-lg  transition-colors duration-200">
                      Enroll now
                    </button>
                  </a>
                </div>
                {/* Character Illustration - Center Column */}
                <div className="lg:w-[53%] md:w-full w-full lg:flex md:flex grid justify-center items-center">
                  <div className="lg:col-span-3 flex justify-center items-center">
                    <div className="relative">
                      <div className="bg-gradient-to-br w-[230px] from-purple-200 to-pink-200 relative max-w-sm">
                        <div>
                          <img
                            src={course.image || "/placeholder.svg"}
                            alt={course.title}
                            className="w-full h-64 object-cover rounded-tl-2xl rounded-bl-2xl  mb-4"
                          />
                        </div>
                        <div className="flex justify-center bottom-[-20px] left-[68px] absolute bg-white px-4 py-2 rounded-lg items-center">
                          <p className="text-center  font-medium text-[#113296] font-Outfit text-base">
                            {course.title}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Course Info Sidebar - Right Column */}
                  <div className="lg:col-span-4">
                    <div className="bg-[#113296] text-white rounded-2xl p-6 max-w-sm ml-auto">
                      <div className="space-y-4 mb-6">
                        <div className="flex items-center gap-4 font-DM_SANS font-normal text-base text-white">
                          <span className="font-medium text-lg">Age:</span>
                          <span>{course.age}</span>
                          <span className="font-medium text-lg ml-4">
                            Duration:
                          </span>
                          <span>{course.duration}</span>
                        </div>
                        <div>
                          <span className="font-medium font-DM_SANS text-lg text-white">
                            Requirement:
                          </span>
                          <span className="ml-2 font-DM_SANS font-normal text-base">
                            {course.requirements}
                          </span>
                        </div>
                        <div>
                          <span className="font-medium text-lg">Price:</span>
                          <span className="ml-2 font-DM_SANS font-normal text-base">
                            {course.price}
                          </span>
                        </div>
                      </div>
                      <div className="space-y-3 pt-5">
                        <button
                          onClick={() => setShowCurriculumModal(true)}
                          className="w-[200px] font-Outfit font-medium text-base bg-[#FF4B01] hover:bg-orange-600 text-white py-3 rounded-lg transition-colors duration-200"
                        >
                          View Curriculum
                        </button>
                        <div className="pt-4 font-DM_SANS font-medium text-base ">
                          <p className="mb-1 lg:w-[200px]">
                            Start your Tech training journey TODAY!
                          </p>
                          <p className="">Register NOW!!!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Related Courses Section */}
          <RelatedCourses courses={relatedCourses} />
        </>
      ) : (
        <div className="min-h-[calc(100vh-6rem)] flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Course Not Found
            </h1>
            <button
              onClick={() => navigate("/cephas-kids/all-courses")}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
            >
              Back to All Courses
            </button>
          </div>
        </div>
      )}

      {/* What we offer */}
      <div>
        <WhatWeOffer />
      </div>

      {/* What Sets Us Apart? */}
      <div>
        <WhatSetsUsApart />
      </div>
      {/* Hear What They're Saying About Us */}
      <div>
        <Testimonials />
      </div>
      {/* Frequently asked questions */}
      <div>
        <FAQ />
      </div>
      {/* Subscribing */}
      <div>
        <NewsletterSubscription />
      </div>
      {/* Footer */}
      <div>
        <Footer />
      </div>

      {/* Curriculum Modal */}
      <CurriculumModal
        isOpen={showCurriculumModal}
        onClose={() => setShowCurriculumModal(false)}
        course={course}
      />
    </div>
  );
};

export default CourseDetail;

// import { useParams, useNavigate } from "react-router-dom";
// import {
//   getCourseById,
//   getRelatedCourses,
// } from "../../components/cephas-kids/CourseData";
// import Nav from "../../components/nav/nav.component";
// import RelatedCourses from "../../components/cephas-kids/RelatedCourses";
// import WhatWeOffer from "../../components/cephas-kids/what-we-offer";
// import WhatSetsUsApart from "../../components/cephas-kids/WhatSetsUsApart";
// import Testimonials from "../../components/cephas-kids/Testimonials";
// import FAQ from "../../components/cephas-kids/Faq";
// import NewsletterSubscription from "../../components/cephas-kids/NewsletterSubscription";
// import Footer from "../../components/footer/footer.component";

// const CourseDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const course = getCourseById(id);
//   const relatedCourses = getRelatedCourses(id, 2);

//   return (
//     <div className="min-h-screen">
//       {/* Navbar is always rendered with light variant */}
//       <Nav variant="dark" />
//       {course ? (
//         <>
//           {/* Course Detail Section */}
//           <div className="pt-24 pb-16 px-4 md:px-6 lg:px-16 bg-gradient-to-r from-[#FF4B01]/5 to-[#113296]/10">
//             <div className=" mx-auto">
//               <div className="grid grid-cols-1 lg:flex items-center gap-12">
//                 {/* Course Content - Left Column */}
//                 <div className=" lg:w-[47%] md:w-full w-full">
//                   <h1 className="text-3xl md:text-4xl lg:text-5xl font-DM_SANS font-bold text-[#113296] mb-6">
//                     {course.title}
//                   </h1>
//                   <div className="prose prose-lg max-w-none mb-8">
//                     <p className="text-[#1B1B1B] font-DM_SANS font-normal text-lg leading-relaxed text-justify">
//                       {course.description}
//                     </p>
//                   </div>
//                   <a
//                     href="http://tinyurl.com/cephaskids"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     <button className="bg-[#FF4B01] font-Outfit font-medium text-xl hover:bg-orange-600 text-white px-8 py-3 rounded-lg  transition-colors duration-200">
//                       Enroll now
//                     </button>
//                   </a>
//                 </div>
//                 {/* Character Illustration - Center Column */}
//                 <div className="lg:w-[53%] md:w-full w-full lg:flex md:flex grid justify-center items-center">
//                   <div className="lg:col-span-3 flex justify-center items-center">
//                     <div className="relative">
//                       <div className="bg-gradient-to-br w-[230px] from-purple-200 to-pink-200 relative max-w-sm">
//                         <div>
//                           <img
//                             src={course.image}
//                             alt={course.title}
//                             className="w-full h-64 object-cover rounded-tl-2xl rounded-bl-2xl  mb-4"
//                           />
//                         </div>
//                         <div className="flex justify-center bottom-[-20px] left-[68px] absolute bg-white px-4 py-2 rounded-lg items-center">
//                           <p className="text-center  font-medium text-[#113296] font-Outfit text-base">
//                             {course.title}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/* Course Info Sidebar - Right Column */}
//                   <div className="lg:col-span-4">
//                     <div className="bg-[#113296] text-white rounded-2xl p-6 max-w-sm ml-auto">
//                       <div className="space-y-4 mb-6">
//                         <div className="flex items-center gap-4 font-DM_SANS font-normal text-base text-white">
//                           <span className="font-medium text-lg">Age:</span>
//                           <span>{course.age}</span>
//                           <span className="font-medium text-lg ml-4">
//                             Duration:
//                           </span>
//                           <span>{course.duration}</span>
//                         </div>
//                         <div>
//                           <span className="font-medium font-DM_SANS text-lg text-white">
//                             Requirement:
//                           </span>
//                           <span className="ml-2 font-DM_SANS font-normal text-base">
//                             {course.requirements}
//                           </span>
//                         </div>
//                         <div>
//                           <span className="font-medium text-lg">Price:</span>
//                           <span className="ml-2 font-DM_SANS font-normal text-base">
//                             {course.price}
//                           </span>
//                         </div>
//                       </div>
//                       <div className="space-y-3 pt-5">
//                         <a
//                           href={course.curriculumFile}
//                           download={`${course.title}-Curriculum.pdf`}
//                         >
//                           <button className="w-[200px] font-Outfit font-medium text-base bg-[#FF4B01] hover:bg-orange-600 text-white py-3 rounded-lg transition-colors duration-200">
//                             Download Curriculum
//                           </button>
//                         </a>
//                         {/* <a
//                           href={course.roadmapFile}
//                           download={`${course.title}-Roadmap.pdf`}
//                         >
//                           <button className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-lg font-medium transition-colors duration-200">
//                             Download Roadmap
//                           </button>
//                         </a> */}
//                         <div className="pt-4 font-DM_SANS font-medium text-base ">
//                           <p className="mb-1 lg:w-[200px]">
//                             Start your Tech training journey TODAY!
//                           </p>
//                           <p className="">Register NOW!!!</p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Related Courses Section */}
//           <RelatedCourses courses={relatedCourses} />
//         </>
//       ) : (
//         <div className="min-h-[calc(100vh-6rem)] flex items-center justify-center">
//           <div className="text-center">
//             <h1 className="text-2xl font-bold text-gray-800 mb-4">
//               Course Not Found
//             </h1>
//             <button
//               onClick={() => navigate("/kids/all-courses")}
//               className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
//             >
//               Back to All Courses
//             </button>
//           </div>
//         </div>
//       )}

//       {/* What we offer */}
//       <div>
//         <WhatWeOffer />
//       </div>

//       {/* What Sets Us Apart? */}
//       <div>
//         <WhatSetsUsApart />
//       </div>
//       {/* Hear What They’re Saying About Us */}
//       <div>
//         <Testimonials />
//       </div>
//       {/* Frequently asked questions */}
//       <div>
//         <FAQ />
//       </div>
//       {/* Subscribing */}
//       <div>
//         <NewsletterSubscription />
//       </div>
//       {/* Footer */}
//       <div>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default CourseDetail;
